<div class="tour-title-wrapper">
    <span class="tour-title">{{'Zimmerkategorien'}}</span>
</div>

<div class="tour-wrapper">
    <ng-container *ngFor="let item of sortArray(roomIdList)| slice:0:slicenbr">
        <button class="tour-item-wrapper-ext" (click)="selected(item)" matRipple>
            <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                'check_box_outline_blank'}}</mat-icon>
            <div class="bestprc">
                <span class="tour-item-name-ext">{{item.name}}</span>
                <span class="bestprcit">{{'ab'}} {{item.bestPricePerPerson?.value + ' ' + item.bestPricePerPerson?.currency}}
                    p.P.</span>
            </div>
        </button>
    </ng-container>
    <ng-container *ngIf="roomIdList.length > 5">
        <ng-container *ngIf="(slicenbr < roomIdList.length) else less">
            <button class="showallbtn" (click)="showMore(roomIdList.length)" matRipple>
                <span>{{'alle'}} {{roomIdList.length}} {{'anzeigen'}}</span>
            </button>
        </ng-container>
        <ng-template #less>
            <button class="showallbtn" (click)="showMore(5)" matRipple>
                <span>{{'weniger anzeigen'}}</span>
            </button>
        </ng-template>
    </ng-container>
</div>